import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { IAppStore } from '../types/IAppStore';
// import { useGatewayStatus } from '../entities/guestmeNotifications';
import {parsePhone} from "../helpers/helpers";

export const selectorRestaurant = createSelector(
  [(store: IAppStore) => store],
  store => store.cabinet.currentRestaurant,
);

export function useRestaurant() {
  return useSelector(selectorRestaurant);
}

export const selectorRestaurantId = createSelector(
  [selectorRestaurant],
  restaurant => restaurant && restaurant.id,
);

export function useRestaurantId() {
  return useSelector(selectorRestaurantId);
}

export const selectorRequiredEmptyAttributes = createSelector(
  [selectorRestaurant],
  restaurant => {
    const requiredEmptyAttributes: Array<string> = [];

    if (!restaurant?.name) {
      requiredEmptyAttributes.push('name');
    }

    if (!restaurant?.description) {
      requiredEmptyAttributes.push('description');
    }

    if (!restaurant.info?.phone) {
      requiredEmptyAttributes.push('phone');
    }

    if (!restaurant?.kitchens || restaurant.kitchens.length === 0) {
      requiredEmptyAttributes.push('kitchens');
    }

    if (!restaurant?.address || Object.keys(restaurant.address).length === 0) {
      requiredEmptyAttributes.push('address');
    }

    return requiredEmptyAttributes;
  },
);

export function useRequiredEmptyAttributes() {
  return useSelector(selectorRequiredEmptyAttributes);
}

export const selectorIsRestaurantGuestmeNotifications = createSelector(
  [selectorRestaurant],
  restaurant => {
    const { isEnabled, gateways } = restaurant.settings.smsNotificationSettings;
    return isEnabled && gateways.some(gateway => gateway.type === "GUESTME");
  },
);

export function useIsRestaurantGuestmeNotifications() {
  return useSelector(selectorIsRestaurantGuestmeNotifications);
}

/**
 * Проверяет, подключен ли хотя бы один шлюз уведомлений.
 * SMS шлюзы (SMSC, SMS_AERO, CHAT_PUSH) считаются подключенными если isEnabled.
 * GUESTME шлюз считается подключенным, если авторизован WhatsApp или Telegram.
 */
export function useHasAnyConnectedGateway() {
  const restaurant = useRestaurant();
  // const { data: gatewayStatus } = useGatewayStatus();

  if (!restaurant) {
    return false;
  }

  const { isEnabled, gateways } = restaurant.settings.smsNotificationSettings;

  if (!isEnabled) {
    return false;
  }

  // Проверяем SMS шлюзы (не GUESTME)
  const hasSmsGateway = gateways.some(
    (gateway) => gateway.type !== 'GUESTME' && gateway.isEnabled
  );

  if (hasSmsGateway) {
    return true;
  }

  // Проверяем GUESTME шлюз
  const hasGuestmeGateway = gateways.some(
    (gateway) => gateway.type === 'GUESTME' && gateway.isEnabled
  );

  return hasGuestmeGateway;

  // if (!hasGuestmeGateway) {
  //   return false;
  // }

  // // GUESTME включен — проверяем авторизацию мессенджеров
  // const isWhatsappAuthorized = gatewayStatus?.whatsappAuthStatus === 'AUTHORIZED';
  // const isTelegramAuthorized = gatewayStatus?.telegramAuthStatus === 'AUTHORIZED';

  // return isWhatsappAuthorized || isTelegramAuthorized;
}
